import { useQuery } from 'react-query';
import AffordableWaitlistService from '../../services/affordableWaitlistService';
import WaitlistConfigurationService from '../../services/waitlistConfigurationService';

const affordableWaitlistService = new AffordableWaitlistService();
const waitlistConfigurationService = new WaitlistConfigurationService();

export function useFetchAffordableWaitlist(
  organizationId: string,
  propertyId: string,
  applicationId: string,
  enabled: boolean = true,
) {
  const queryKey = ['getAffordableWaitlistByApplicationId', applicationId];
  return useQuery(
    queryKey,
    () =>
      affordableWaitlistService.getAffordableWaitlistByApplicationId(
        organizationId,
        propertyId,
        applicationId,
      ),
    {
      enabled:
        Boolean(
          organizationId.length && propertyId.length && applicationId.length,
        ) && enabled,
      refetchOnWindowFocus: false,
    },
  );
}

export function useFetchWaitlistConfiguration(
  propertyId: string,
  enabled: boolean = true,
) {
  return useQuery(
    ['waitlistConfiguration', propertyId],
    () =>
      waitlistConfigurationService.getWaitlistConfigurationByPropertyId(
        propertyId,
      ),
    {
      enabled: Boolean(propertyId.length) && enabled,
      refetchOnWindowFocus: false,
    },
  );
}

export function useFetchWaitlistEditDetails(
  organizationId: string,
  propertyId: string,
  applicationId: string,
  enabled: boolean = true,
) {
  const queryKey = ['getWaitlistEditDetails', applicationId];
  return useQuery(
    queryKey,
    () =>
      affordableWaitlistService.getWaitlistEditDetails(
        organizationId,
        propertyId,
        applicationId,
      ),
    {
      enabled:
        Boolean(
          organizationId.length && propertyId.length && applicationId.length,
        ) && enabled,
      refetchOnWindowFocus: false,
    },
  );
}
